import { Column, type BoxProps } from "@hightouch/htui";
import type { ReactElement } from "react";

interface Props extends BoxProps {
  children: ReactElement[];
}

export const Mask = ({ children, ...props }: Props) => (
  <Column
    {...props}
    style={{
      mask: maskCss,
    }}
  >
    {children}
  </Column>
);

export const maskCss =
  "linear-gradient(0deg, rgba(0, 0, 0, 0) 10%, rgb(0, 0, 0) 100%)";
